import { SxProps } from '@mui/material';

export const headerMiniCartDrawerIconSX: SxProps = {
	color: 'grey.200',
	cursor: 'pointer',
	'&:hover': {
		color: 'primary.main',
	},
};

export const headerMiniCartDrawerHeaderIconSX: SxProps = {
	color: 'primary.main',
};

export const headerMiniCartDrawerHeaderSX: SxProps = {
	p: '10px 20px',
};

export const headerMiniCartDrawerHeaderTitleSX: SxProps = {
	color: 'grey.500',
	fontSize: '18px',
	fontWeight: 300,
};

export const headerMiniCartDrawerContainerSX: SxProps = {
	'& .MuiDrawer-paper': {
		maxHeight: '80vh',
		zIndex: '1600',
		bottom: '60px',
		boxShadow: 3,
		transition: 'none',
	},
};
